import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

// Singleton Supabase client with custom lock for cross-tab safety
let supabaseInstance: ReturnType<typeof createClient> | null = null;

function createSupabaseClient() {
  if (!supabaseUrl || !supabaseAnonKey) {
    console.warn("Supabase: Missing environment variables. Auth and database features will be unavailable.");
    return null;
  }

  try {
    return createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storage: typeof window !== "undefined" ? window.localStorage : undefined,
        lock: (name: string, acquireTimeout: number, fn: () => Promise<void>) => {
          if (typeof navigator !== "undefined" && navigator.locks) {
            return navigator.locks.request(name, { timeout: acquireTimeout }, fn);
          }
          return fn();
        },
      },
    });
  } catch (err) {
    console.warn("Supabase: Failed to create client:", err);
    return null;
  }
}

export const supabase = (() => {
  if (!supabaseInstance) {
    supabaseInstance = createSupabaseClient();
  }
  return supabaseInstance;
})();